import { FilmSessionFragment, FilmTileFragment, SessionTicketsFragment, SingleFilmPageFragment } from "@generated-types"
import { formatStaticDateTime } from "@utils/date-format"

export const TrackingHelpers = {
  sessionAttrs(session: SessionTicketsFragment | FilmSessionFragment | null | undefined) {
    if (!session) return {}
    const sessionLabel = [
      session.info?.venue?.titleSimple,
      session.info?.venue?.titleSub,
      formatStaticDateTime(session.info?.dateTime!),
    ]
      .filter(Boolean)
      .join(" / ")

    return {
      "data-mixpanel-session": sessionLabel,
      "data-mixpanel-ferve-id": session.info?.ferveId,
    }
  },
  filmAttrs(film: FilmTileFragment | SingleFilmPageFragment | null | undefined) {
    if (!film) return {}
    return {
      "data-mixpanel-film": film.title,
      "data-mixpanel-film-uri": film.uri,
    }
  },
}
